import React, { createContext, useContext, useEffect, useMemo } from "react";

// Single product theme: Daylight (light). Dark themes were retired.
export const THEMES = [{ id: "daylight", name: "Daylight", swatch: ["#F6F8FC", "#0284C7"], light: true }];

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", "daylight");
    localStorage.removeItem("tj-theme");
  }, []);

  const value = useMemo(() => ({ theme: "daylight", setTheme: () => {}, isLight: true, THEMES }), []);
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);
